import {
  AppBar,
  Box,
  Drawer,
  IconButton,
  ListItemIcon,
  MenuItem,
  Select,
  Stack,
  Typography,
  styled,
} from '@mui/material'
import Link from 'next/link'
import Image from 'next/image'
import React, { useState } from 'react'
import { Email, Menu, Telegram, Twitter } from '@mui/icons-material'
import DescriptionIcon from '@mui/icons-material/Description'
import { useAccount, useNetwork, useSwitchNetwork } from 'wagmi'
import { useWeb3Modal } from '@web3modal/react'
import { hide, show } from '@ebay/nice-modal-react'
import { useWallet } from '../common/WalletContext'
import BitcoinWalletConnectDialog from '../common/BitcoinConnectDialog'
import TokenLogo from '../common/TokenLogo'
import ConnectWalletButton from '../common/Header/ConnectWalletButton'
import styles from './styles'
import SocialMediaLinkGroup from './SocialMediaLinkGroup'
import Logo from './Logo'
import LogoSvg from '@/assets/imgs/logo.svg'
import MenuSvg from '@/assets/imgs/Mobile/menu.svg'
import { ReactComponent as RightGreenSvg } from '@/assets/imgs/Mobile/rightGreen.svg'
import MenuCloseSvg from '@/assets/imgs/Mobile/menuClose.svg'
import { ReactComponent as RightSVG } from '@/assets/imgs/Mobile/right.svg'

import { ReactComponent as MediumSvg } from '@/assets/imgs/Mobile/medium.svg'
import { CHAIN_INFO, ETHEREUM_CHAIN_ID, SUPPORTED_CHAIN } from '@/constants'
import { toSmallAddr } from '@/utils'
import bitcoinSvg from '@/assets/imgs/bitcoin.svg'
import { HEADER_LINKS } from '@/constants/links'
import { shortenAddress, shortenBtcAddress } from '@/utils/address'

export type IHeaderMobileProps = {}
// const TextLogo = styled(Typography)`
//   font-weight: 400;
//   font-size: 15.2727px;
//   line-height: 20px;
//   color: #bfff0b;
// `

const HeaderMobile: React.FC<IHeaderMobileProps> = ({}) => {
  const [showSlider, setShowSlider] = useState<boolean>(false)
  const { walletType, isConnected, address } = useWallet()

  return (
    <AppBar sx={styles.root}>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <Logo />

        <Stack direction={'row'} spacing={12} alignItems={'center'}>
          <ConnectWalletButton />

          <IconButton
            onClick={() => {
              setShowSlider(true)
            }}
          >
            <Menu />
          </IconButton>
        </Stack>
      </Stack>

      <Drawer
        sx={{
          '& .MuiDrawer-paper': {
            height: '100vh',
            background: '#030401',
          },
        }}
        anchor="top"
        open={showSlider}
        onClose={() => {
          setShowSlider(false)
        }}
      >
        <Stack px={24} height={86} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
          <Logo />

          <Image
            src={MenuCloseSvg}
            alt={'menu'}
            width={24}
            height={24}
            onClick={() => {
              setShowSlider(false)
            }}
          />
        </Stack>

        <Box
          p={'32px 24px 25px 24px'}
          display={'flex'}
          flex={1}
          flexDirection={'column'}
          justifyContent={'space-between'}
        >
          <Stack spacing={20} direction={'column'}>
            {address && (
              <Typography>
                {walletType === 'Btc'
                  ? shortenBtcAddress(address)
                  : walletType === 'Evm'
                  ? shortenAddress(address)
                  : address}
              </Typography>
            )}

            <Stack direction={'column'} spacing={8}>
              <Link
                href="/account"
                onClick={() => {
                  setShowSlider(false)
                }}
              >
                <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                  <Typography fontSize={20} lineHeight={'26px'} fontWeight={500} color={'#FFFFFF'}>
                    Account
                  </Typography>
                  <RightGreenSvg />
                </Box>
              </Link>
              <Typography
                fontSize={14}
                lineHeight={'18px'}
                fontWeight={500}
                color={'#FFFFFF'}
                sx={{
                  opacity: 0.4,
                }}
              >
                View your portfolio of related assets on this chain
              </Typography>
            </Stack>

            {HEADER_LINKS.map((link) => {
              if (link.href) {
                return (
                  <Link
                    key={link.title}
                    href={link.href}
                    onClick={() => {
                      setShowSlider(false)
                    }}
                  >
                    <Box
                      sx={{
                        borderBottom: '1px solid rgba(57, 61, 73, 0.5)',
                        pb: 30,
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Typography color={'#FCFCFD'} fontSize={16} lineHeight={'20px'} fontWeight={400}>
                        {link.title}
                      </Typography>
                      <RightSVG />
                    </Box>
                  </Link>
                )
              } else {
                return (
                  <Box
                    key={link.title}
                    sx={{
                      borderBottom: '1px solid rgba(57, 61, 73, 0.5)',
                      pb: 30,
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Typography color={'#FCFCFD'} fontSize={16} lineHeight={'20px'} fontWeight={400}>
                      {link.title} <span style={{ opacity: 0.4 }}>(SOON)</span>
                    </Typography>
                    <RightSVG />
                  </Box>
                )
              }
            })}
          </Stack>

          <SocialMediaLinkGroup />
        </Box>
      </Drawer>
    </AppBar>
  )
}

export default HeaderMobile
